define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/dom-class",
	"dojo/dom-style",
	"csi/html/Widget",
	"csi/page",
	"csi/xml"
], function(declare, event, domClass, domStyle, Html, page, xml) {

	return declare(Html, {
		onClick: function(/*Event*/e) {
			// summary: prevent action from being clicked while another is running
			if (domClass.contains(this.domNode, "dijitDisabled")) {
				event.stop(e);
				return;
			}

			this.inherited(arguments);
		},

		preAction: function(/*Controller*/ac) {
			// summary: disable actions in view
			this.inherited(arguments);
			domClass.add(this.domNode, "dijitDisabled");
		},

		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: enable view now that action is complete
			if (this.inherited(arguments)) {
				domClass.remove(this.domNode, "dijitDisabled");
				domStyle.set(this.domNode, "height", "");
			}
		},

		postActionState: function(ac) {
			// summary: refresh view and tabs
			return page.refreshViews();
		},

		_buildView: function() {
			// summary: if node is read-only, then disable all actions
			domClass.toggle(this.domNode, "dijitDisabled", xml.nodeHasFlag(this.getViewNode(), xml.NODE_FLAG_NOEDIT));
			this.inherited(arguments);
		}
	});
});